import { strLang } from "../functions/strLang";
import { user } from "../data/main";
import SettingsIcon from "@mui/icons-material/Settings";
import Section from "./Section";
import { avatarImages } from "../data/avatarsData";
import PersonIcon from "@mui/icons-material/Person";
import DeleteIcon from "@mui/icons-material/Delete";
import EmojiPeopleIcon from "@mui/icons-material/EmojiPeople";
import packageJson from "../../package.json";
// import { pbfToGeoJSON } from "../TheMap/functions/getOfflineMap";
import { tileList } from "../data/tilesList";
import Header from "../components/Header";
import MainFrame from "../components/MainFrame";
import useSettings from "./useSettings";
import GenericModal from "../components/GenericModal";
import { isAdmin, isEditor } from "../functions/isEditor";
import StdInput from "../components/StdInput";

export default function Settings(props) {
  const {
    tileImg,
    changeTile,
    search,
    updateUserList,
    searchUsers,
    checkBox,
    setMsgData,
    createHRef,
    msgType,
    open,
    closeMsg,
    setOpen,
    tileInfo,
  } = useSettings(props);

  return (
    <MainFrame width={props.width}>
      {/* <div onClick={() => pbfToGeoJSON("")}>asdfasd</div> */}
      <Header MainIcon={SettingsIcon} color={props.iconColor} />
      <div
        style={{
          position: "relative",
          flex: 1,
          overflow: "auto",
          backgroundColor: "white",
        }}
      >
        {isEditor && (
          <>
            <Section title={strLang("data")}>
              <div>
                <label>
                  <b>{strLang("name")}</b>
                </label>
                <br />
                {isAdmin ? (
                  <input
                    defaultValue={localStorage.getItem("groupName") ?? ""}
                    disabled
                  />
                ) : (
                  localStorage.getItem("groupName")
                )}
              </div>
              <div>
                <label>
                  <b>{strLang("email")}</b>
                </label>
                <br />
                {isAdmin ? (
                  <input
                    defaultValue={localStorage.getItem("email") ?? ""}
                    disabled
                  />
                ) : (
                  localStorage.getItem("email")
                )}
              </div>
            </Section>
            <Section title={strLang("map")}>
              <img
                className="tileImg"
                topstyle={{
                  padding: 10,
                  boxSizing: "border-box",
                }}
                src={tileImg}
                alt={"avatar"}
              />
              <StdInput
                value={tileInfo}
                select={tileList
                  .filter((_, index) => index > 0)
                  .map((e) => {
                    return { value: e, label: strLang(e, "tileNames") };
                  })}
                change={(value) => changeTile(value)}
                style={{ width: 200 }}
              />
            </Section>
            <Section title={strLang("users")}>
              <StdInput
                value={search}
                change={(e) => {
                  updateUserList(e.target.value);
                }}
              />
              <div
                style={{
                  width: 400,
                  height: 200,
                  overflow: "auto",
                  border: "#767676 solid 2px",
                  boxSizing: "border-box",
                }}
                topstyle={{
                  padding: 10,
                  boxSizing: "border-box",
                }}
              >
                <table width={"100%"} style={{ borderCollapse: "collapse" }}>
                  <thead>
                    <tr className="hCabecera">
                      {/* <th>
                    <Check style={{ color: "#000" }} />
                  </th> */}
                      <th colSpan="2">{strLang("name")}</th>
                      <th>{strLang("country")}</th>
                      <th>
                        <EmojiPeopleIcon />
                      </th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {searchUsers.map((o, index) => (
                      <tr
                        key={index}
                        style={{
                          backgroundColor:
                            index % 2 === 0 ? "#FFFFFF" : "#F5F5F5",
                        }}
                      >
                        {/* <td align="center">{checkBox(o, "ACTIVE")}</td> */}
                        <td align="center">
                          {o.IMA > 0 ? (
                            <img
                              src={avatarImages["ani" + o.IMA].svg}
                              alt="avatar"
                              style={{ width: 50 }}
                            />
                          ) : (
                            <PersonIcon
                              style={{ fontSize: 40, color: "gray" }}
                            />
                          )}
                        </td>
                        <td>{o.NOMBRE}</td>
                        <td>{o.COUNTRY}</td>
                        <td align="center">{checkBox(o, "LEAD")}</td>
                        <td>
                          {o.ORD !== Number(user.id) && o.ROL < 2 && (
                            <DeleteIcon
                              style={{
                                color: "red",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                setMsgData({ id: o.ORD, name: o.NOMBRE });
                                setOpen("askDelete");
                              }}
                            />
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </Section>
          </>
        )}
        <Section title={strLang("version")}>
          <div>
            {process.env.REACT_APP_NAME} {packageJson.version}
          </div>
        </Section>
        <Section title={strLang("legalInfo")} final={true}>
          {/* <div>
            <b>{process.env.REACT_APP_NAME}</b>
            <br />
            {createHRef(strLang("termsOfUse"), "")}
            {createHRef("Política de Privacidad", "")}
          </div> */}
          <div>
            <b>OpenStreetMap</b>
            <br />
            {createHRef(
              strLang("termsOfUse"),
              "https://osmfoundation.org/wiki/Terms_of_Use"
            )}
          </div>
          {/* <div>
            <b>Google</b>
            <br />
            {createHRef(
              strLang("termsOfUse"),
              "https://cloud.google.com/maps-platform/terms"
            )}
            {createHRef(
              "Política de Privacidad",
              "https://policies.google.com/privacy?hl=es-419"
            )}
          </div> */}
          <div>
            <b>Esri</b>
            <br />
            {createHRef(
              strLang("privacyCookies"),
              "https://www.esri.com/en-us/privacy/overview"
            )}
            {createHRef(
              strLang("legalInfo"),
              "https://www.esri.com/content/dam/esrisites/en-us/media/legal/terms-and-conditions/website-terms.pdf"
            )}
          </div>
        </Section>
      </div>
      <GenericModal open={open} data={msgType[open]} close={closeMsg} />
    </MainFrame>
  );
}
